export default {
    init() {
      console.log('faq');
      const dropDowns = document.querySelectorAll('.dropDown');

      function removeActive(){
        for(const dropDown of dropDowns){
          dropDown.classList.remove('active')
        }
      }

      dropDowns.forEach(dropDown => {
        dropDown.addEventListener('click', () => {
          // removeActive()
            dropDown.classList.toggle('active')
        })

      });
    },
    finalize() {
      // JavaScript to be fired on the faq page, after the init JS
    },
  };
  